window.$ = jQuery;
import gsap from 'gsap';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';


const search = (function() {

    $(".search-results-primary__open-filters").on("click", function() {
        $(".search-results-filters-outer").addClass("mobile-visible");
        $("html, body").addClass("scroll-locked");
    });

    $(".search-results-filters__header__close").on("click", function(e) {
        e.preventDefault();
        $(".search-results-filters-outer").removeClass("mobile-visible");
        $("html, body").removeClass("scroll-locked");
        return false;
    });

    $(".search-btn").on("click", function(e) {
        if ($(".search-bar").is(":visible")) {
            gsap.to(".search-bar", {opacity: 0, height: "0px", duration: 0.5, display: "none", ease: "power2.out", onComplete: window.sizeUnderlay, onUpdate: window.sizeUnderlay});
        } else {
            gsap.fromTo(".search-bar", {opacity: 0, height: 0}, {opacity: 1, height: "50px", duration: 0.5, display: "flex", ease: "power2.out", onComplete: window.sizeUnderlay, onUpdate: window.sizeUnderlay});
        }
    });

    $(".close-search-btn").on("click", function(e) {
        gsap.to(".search-bar", {opacity: 0, height: 0, duration: 0.5, display: "none", ease: "power2.out"});
    });

    $(".search-results-filters__filter__heading").on("click", function(e) {
        $(this).parent().toggleClass("collapsed");
    });

    $(".search-results-filters__filter__more").on("click", function(e) {
        $(this).parent().toggleClass("expanded");
        $(this).text($(this).text() == "More" ? "Less" : "More");
    });

    $(".search-page-search-form").on("submit", function(e) {
        if ($(".search-results-primary__form__input").val() !== $(".search-results-primary__form__input").attr("data-current-search")) {
            $(".search-results-filters input").each(function() {
                $(this).prop("checked", false);
            });
            $(this).parent().parent().find(".min-max-slider")[0].noUiSlider.reset();
        }
    });

    $(".min-max-slider").each(function() {
        const slider = $(this)[0];
        var min = parseInt($(this).attr("data-min"));
        var max = parseInt($(this).attr("data-max"));
        var $minEl = $(this).parent().parent().find(".min-val");
        var $maxEl = $(this).parent().parent().find(".max-val");
        var setMin = $minEl.attr("value") ? $minEl.attr("value") : min;
        var setMax = $maxEl.attr("value") ? $maxEl.attr("value") : max;


        noUiSlider.create(slider, {
            start: [setMin, setMax],
            connect: true,
            step: 1,
            range: {
                'min': min,
                'max': max
            },
            pips: {
                mode: 'count',
                values: 4,
                density: 2
            }
        });

        slider.noUiSlider.on('update', function (values, handle) {
            var normalizedValueMin = Math.round(values[0]);
            var normalizedValueMax = Math.round(values[1]);
            $minEl.attr("value", normalizedValueMin);
            $maxEl.attr("value", normalizedValueMax);
        });
    });

    $(".search-results-filters__header__clear").on("click", function(e) {   
        e.preventDefault();
        $(".search-results-filters input").each(function() {
            $(this).prop("checked", false);
        });
        $(this).parent().parent().find(".min-max-slider")[0].noUiSlider.reset();
        $(".search-page-search-form").submit();
        return false;
    });

    $(".search-results-primary__sort-select").on("change", function(e) {
        $(".search-page-search-form").submit();
    });


})();

export default search;